import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteForever';

export default function PricelistDeleteDialog({ open, onClose, pricelistName, onConfirm, loading = false }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ta bort prislista</DialogTitle>
      <DialogContent>
        <Stack spacing={2} textAlign="center">
          <Typography>Här kan du ta bort en prislista från systemet.</Typography>
          <Typography>
            För att det ska fungera får inte prislistan vara kopplad till någon produkt. Om så är fallet kommer ett felmeddelande att visas.
          </Typography>
          <Typography>
            Är du säker på att du vill ta bort prislistan<b>{pricelistName}</b>?
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClose}>Avbryt</Button>
        <Button
          variant="contained"
          color="error"
          startIcon={loading ? <CircularProgress size={16} /> : <DeleteIcon />}
          onClick={onConfirm}
          disabled={loading}
        >
          Ja, ta bort prislistan
        </Button>
      </DialogActions>
    </Dialog>
  );
}
